






























import Vue from 'vue'
import restaurants, { RestaurantList } from '@/services/Restaurants'

export default Vue.extend({
  name: 'RestaurantList',
  data() {
    return {
      restaurantList: ([] as unknown) as RestaurantList,
    }
  },
  mounted() {
    restaurants.getAllRestaurants(r => {
      this.restaurantList = r
    })
  },
  methods: {
    deleteRestaurant(id: string) {
      if (!confirm(this.$i18n.t('admin.restaurants.confirm') + '')) {
        return
      }

      restaurants.deleteRestaurant(id)
    },
  },
})
